/* Tonersa theme JS — predictive search, finder, qty, ajax add-to-cart, sticky ATC, gallery, sort */
(function () {
  'use strict';

  var money = function (cents) {
    try { return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  };

  function toast(msg) {
    var el = document.getElementById('toast');
    if (!el) return;
    /* a11y: unhide FIRST, then write — live-region mutations inside a hidden
       subtree are not announced by screen readers (WCAG 4.1.3). */
    el.textContent = '';
    el.hidden = false;
    el.classList.add('is-on');
    requestAnimationFrame(function () { el.textContent = msg; });
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-on'); el.hidden = true; el.textContent = ''; }, 2600);
  }

  function updateCartCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
    }).catch(function () {});
  }

  /* ---------- AJAX add to cart (quick-add buttons + PDP form) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('.pcard__form, .pdp-form')) return;
    if (form.querySelector('[name="return_to"]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    var old = btn ? btn.textContent : '';
    /* a11y: aria-disabled instead of [disabled] so focus is not thrown to <body> */
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { updateCartCount(); toast('Added to cart ✓'); })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.removeAttribute('aria-disabled'); btn.removeAttribute('aria-busy'); btn.textContent = old; }
      });
  });

  /* ---------- Predictive search ---------- */
  var searchWraps = document.querySelectorAll('[data-predictive-search]');
  searchWraps.forEach(function (wrap) {
    var input = wrap.querySelector('input[type="search"]');
    var results = wrap.querySelector('[data-search-results]');
    if (!input || !results) return;
    var status = wrap.querySelector('[data-search-status]');
    var t;
    function closeResults() {
      results.classList.remove('is-open');
      input.setAttribute('aria-expanded', 'false');
      if (status) status.textContent = '';
    }
    function openResults(n) {
      results.classList.add('is-open');
      input.setAttribute('aria-expanded', 'true');
      if (status) status.textContent = n + (n === 1 ? ' suggestion' : ' suggestions') + ' available. Use Tab to review them.';
    }
    function options() { return Array.prototype.slice.call(results.querySelectorAll('[role="option"]')); }
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') { closeResults(); return; }
      if (e.key === 'ArrowDown' && results.classList.contains('is-open')) {
        var first = options()[0];
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    results.addEventListener('keydown', function (e) {
      var opts = options();
      var at = opts.indexOf(document.activeElement);
      if (at < 0) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); (opts[at + 1] || opts[0]).focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (at === 0) { input.focus(); } else { opts[at - 1].focus(); } }
      else if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeResults(); input.focus(); }
    });
    input.addEventListener('input', function () {
      clearTimeout(t);
      var q = input.value.trim();
      if (q.length < 2) { closeResults(); return; }
      t = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (((data || {}).resources || {}).results || {}).products || [];
            if (!products.length) { closeResults(); return; }
            results.innerHTML = products.map(function (p) {
              return '<a class="sresult" role="option" href="' + p.url + '">' +
                (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=104" alt="">' : '<span></span>') +
                '<span><span class="sresult__title">' + p.title + '</span>' +
                '<span class="sresult__meta">' + (p.body ? '' : '') + '</span></span>' +
                '<span class="sresult__price">' + p.price + '</span></a>';
            }).join('') +
            '<a class="sresults-all" role="option" href="/search?q=' + encodeURIComponent(q) + '">See all results →</a>';
            openResults(products.length);
          }).catch(function () {});
      }, 180);
    });
    document.addEventListener('click', function (e) {
      if (!wrap.contains(e.target)) closeResults();
    });
  });

  /* ---------- Finder ---------- */
  document.querySelectorAll('[data-finder]').forEach(function (finder) {
    var dataEl = finder.querySelector('[data-finder-data]');
    var data = {};
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var sBrand = finder.querySelector('[data-finder-brand]');
    var sFamily = finder.querySelector('[data-finder-family]');
    var sModel = finder.querySelector('[data-finder-model]');
    var go = finder.querySelector('[data-finder-go]');
    if (!sBrand || !sFamily || !sModel || !go) return;
    var fstatus = finder.querySelector('[data-finder-status]');
    function say(m) { if (fstatus) fstatus.textContent = m; }
    function setGo(ready) { go.setAttribute('aria-disabled', ready ? 'false' : 'true'); }

    Object.keys(data).forEach(function (b) { sBrand.add(new Option(b, b)); });

    sBrand.addEventListener('change', function () {
      sFamily.length = 1; sModel.length = 1;
      sModel.disabled = true; setGo(false);
      var fams = data[sBrand.value] || {};
      Object.keys(fams).forEach(function (f) { sFamily.add(new Option(f, f)); });
      sFamily.disabled = !sBrand.value;
      say(sBrand.value ? Object.keys(fams).length + ' printer families available for ' + sBrand.value + '. Step 2 is now available.' : '');
    });
    sFamily.addEventListener('change', function () {
      sModel.length = 1; setGo(false);
      var models = (data[sBrand.value] || {})[sFamily.value] || [];
      models.forEach(function (m) { sModel.add(new Option(m, m)); });
      sModel.disabled = !sFamily.value;
      say(sFamily.value ? models.length + ' printer models available. Step 3 is now available.' : '');
    });
    sModel.addEventListener('change', function () {
      setGo(!!sModel.value);
      say(sModel.value ? sModel.value + ' selected. Activate Show my cartridges to see matching toner.' : '');
    });
    go.addEventListener('click', function (e) {
      if (!sModel.value || go.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      window.location.href = '/search?q=' + encodeURIComponent(sModel.value);
    });
  });

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;
    var qty = e.target.closest('.qty');
    var input = qty && qty.querySelector('input');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    input.value = Math.max(1, v + (plus ? 1 : -1));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- PDP: variant select price update ---------- */
  document.querySelectorAll('[data-variant-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var opt = sel.options[sel.selectedIndex];
      var wrap = document.querySelector('[data-price-wrap]');
      if (!wrap || !opt) return;
      var was = opt.dataset.compare ? '<span class="was">' + opt.dataset.compare + '</span>' : '';
      wrap.innerHTML = '<div class="buybox__price"><span class="now">' + opt.dataset.price + '</span>' + was + '</div>';
      var url = new URL(window.location.href);
      url.searchParams.set('variant', opt.value);
      history.replaceState(null, '', url.toString());
    });
  });

  /* ---------- PDP: gallery thumbs ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var main = document.querySelector('[data-main-image] img');
      if (!main) return;
      main.src = btn.dataset.thumb;
      main.removeAttribute('srcset');
      /* a11y: the alt text must follow the image it describes (WCAG 1.1.1) */
      if (btn.dataset.thumbAlt) main.alt = btn.dataset.thumbAlt;
      document.querySelectorAll('[data-thumb]').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    });
  });

  /* ---------- Sticky mobile ATC ---------- */
  var sticky = document.querySelector('[data-sticky-atc]');
  var buybox = document.querySelector('.buybox');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(buybox);
    var stickyBtn = sticky.querySelector('[data-sticky-add]');
    if (stickyBtn) stickyBtn.addEventListener('click', function () {
      var form = document.getElementById('product-form');
      if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
    });
  }

  /* ---------- Collection sort ---------- */
  /* a11y: this used to call window.location on the select's 'change' event, which
     fires on every arrow-key step in some browsers and navigated away mid-choice
     (WCAG 3.2.2 On Input). The sort form now submits from its own Apply button and
     works with JS disabled, so no handler is needed here. */

  /* ---------- Promo slider ---------- */
  document.querySelectorAll('[data-pslider]').forEach(function (slider) {
    var track = slider.querySelector('[data-pslider-track]');
    var slides = track ? track.children : [];
    if (!track || slides.length < 2) return;
    var dots = slider.querySelectorAll('[data-pslider-dot]');
    var i = 0, n = slides.length, timer = null;
    var interval = parseInt(slider.dataset.interval, 10) || 6000;
    var autoplay = slider.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var FOCUSABLE = 'a[href],button,input,select,textarea,[tabindex]';
    var sstatus = slider.querySelector('[data-pslider-status]');
    function go(idx, announce) {
      i = (idx + n) % n;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
        d.setAttribute('aria-current', di === i ? 'true' : 'false');
      });
      /* a11y: off-screen slides are only clipped by overflow:hidden — keep them
         out of the tab order and the accessibility tree (WCAG 2.4.3, 2.4.7). */
      Array.prototype.forEach.call(slides, function (s, si) {
        var off = si !== i;
        if (off) { s.setAttribute('inert', ''); s.setAttribute('aria-hidden', 'true'); }
        else { s.removeAttribute('inert'); s.removeAttribute('aria-hidden'); }
        if (!('inert' in HTMLElement.prototype)) {
          s.querySelectorAll(FOCUSABLE).forEach(function (el) {
            if (off) { el.setAttribute('tabindex', '-1'); } else { el.removeAttribute('tabindex'); }
          });
        }
      });
      slider.dataset.currentSoft = slides[i].classList.contains('pslide--soft') ? 'true' : 'false';
      /* announce manual moves only — an aria-live region on an auto-rotating
         carousel would interrupt the user every few seconds */
      if (announce && sstatus) sstatus.textContent = 'Slide ' + (i + 1) + ' of ' + n;
    }
    /* a11y: never restart rotation while the user is inside the slider with the
       keyboard — only an explicit press of the play control forces it (WCAG 2.2.2). */
    function play(force) {
      if (!autoplay) return;
      if (!force && slider.contains(document.activeElement)) return;
      stop();
      timer = setInterval(function () { go(i + 1); }, interval);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    var prev = slider.querySelector('[data-pslider-prev]');
    var next = slider.querySelector('[data-pslider-next]');
    if (prev) prev.addEventListener('click', function () { go(i - 1, true); play(); });
    if (next) next.addEventListener('click', function () { go(i + 1, true); play(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.dataset.psliderDot, 10), true); play(); }); });
    slider.addEventListener('mouseenter', stop);
    slider.addEventListener('mouseleave', play);
    /* a11y: keyboard focus must pause too, and an auto-rotating carousel needs an
       explicit pause control (WCAG 2.2.2 Pause, Stop, Hide). */
    slider.addEventListener('focusin', stop);
    slider.addEventListener('focusout', function (e) {
      if (!slider.contains(e.relatedTarget)) play();
    });
    var pauseBtn = slider.querySelector('[data-pslider-pause]');
    if (pauseBtn) {
      if (!autoplay) pauseBtn.hidden = true;
      pauseBtn.addEventListener('click', function () {
        var paused = pauseBtn.getAttribute('aria-pressed') === 'true';
        if (paused) { autoplay = slider.dataset.autoplay === 'true'; play(true); }
        else { autoplay = false; stop(); }
        pauseBtn.setAttribute('aria-pressed', paused ? 'false' : 'true');
        pauseBtn.setAttribute('aria-label', paused ? 'Pause slideshow' : 'Play slideshow');
        pauseBtn.textContent = paused ? '❚❚' : '►';
      });
    }
    go(0); play();
  });

  updateCartCount();
})();
